import React from 'react';
import CaptionComponent from '../components/Caption';
import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function Caption(props) {
  return (
    <AddonsContextConsumer>
      {({ constants: { CAPTIONS } }) =>
      <CaptionComponent
        {...props}
        CAPTIONS={CAPTIONS} />}


    </AddonsContextConsumer>);

}

export default Caption;